const { REACT_APP_REACT_ENV, REACT_APP_BASIC_AUTH_KEY } = process.env;

// const localhost = !true
//   ? "http://localhost:3000"
//   : "https://stagingapi.kivihealth.com";

// for sign up only
// const headers = new Headers();
// const appHeaders = {
//   development: {
//     ...headers,
//     Authorization: REACT_APP_BASIC_AUTH_KEY,
//     "Content-Type": "application/json",
//   },
//   staging: {
//     ...headers,
//     Authorization: REACT_APP_BASIC_AUTH_KEY,
//     "Content-Type": "application/json",
//   },
//   production: {
//     ...headers,
//     Authorization: REACT_APP_BASIC_AUTH_KEY,
//     "Content-Type": "application/json",
//   },
// }[REACT_APP_REACT_ENV];

// const BASE_URL = "https://stageapi.kivihealth.com/api-v2021";

const rootURL = {
  development: "https://stagecrmapi.kivihealth.com/",
  staging: "https://stagecrmapi.kivihealth.com/",
  production: "https://crmapi.kivihealth.com/",
}[REACT_APP_REACT_ENV];

const crm = {
  // COMMON
  timeLineURL: rootURL + "api/crmapis/v1/common/doctortimeline",
  employeeUserList: rootURL + "api/crmapis/v1/operations/getusers",

  // OPERATIONS
  crmUserLoginURL: rootURL + "api/crmapis/v1/user/login",
  operationSegmentURL: rootURL + "api/crmapis/v1/operations/getopreationslist",
  getUserDetailsURL: rootURL + "api/crmapis/v1/user/getdetails",
  updateUserDetailsURL: rootURL + "api/crmapis/v1/operations/update",
  listingFilterURL: rootURL + "api/crmapis/v1/operations/getopreationslist",
  searchByDoctorName: rootURL + "api/crmapis/v1/common/getdoctors",
  searchAPI: rootURL + "api/crmapis/v1/common/getsearcheddoctors",
  addNewUserURL: rootURL + "api/crmapis/v1/operations/add",
  citySearchURL: rootURL + "api/crmapis/v1/common/getcities",

  // RENEWAL
  renewalSegmantURL: rootURL + "api/crmapis/v1/renewals/getrenewalslist",
  addRenewalURL: rootURL + "api/crmapis/v1/renewals/add",
  updateRenewalURL: rootURL + "api/crmapis/v1/renewals/update",

  // CUSTOMER CARE
  customerCareSegmentURL:
    rootURL + "api/crmapis/v1/customercarerequest/getrequestslist",
  addNewCustomerCareURL: rootURL + "api/crmapis/v1/customercarerequest/add",
  updateCustomerCareUserDetailsURL:
    rootURL + "api/crmapis/v1/customercarerequest/update",

  // RESET PASSWORD
  sendOTPURL: rootURL + "api/crmapis/v1/common/sendotp",
  verifyOTPURL: rootURL + "api/crmapis/v1/common/verifyotp",
  forgotPasswordURL: rootURL + "api/crmapis/v1/user/forgotpassword",
};

const config = {
  development: {
    ...crm,
  },
  staging: {
    ...crm,
  },
  production: {
    ...crm,
  },
}[REACT_APP_REACT_ENV];

// freeze object
const fObj = Object.freeze(config);

export default fObj;
